// Globals
import { useTranslation } from 'react-i18next';

// Permissions
import { Resource, usePermissions } from '@/modules/Permissions';

// Components
import { Pagination } from '@/components';
import { Table } from '@/ui';
import { getCashRegisterColumns } from './columns';

// Models
import { ICashRegister } from '@/models/financialSettings.model';

type TCashRegisterList = {
  cashRegisters: ICashRegister[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onDelete: (item: ICashRegister) => void;
  onUpdate: (item: ICashRegister) => void;
};

const CashRegisterList = ({
  cashRegisters,
  isLoading,
  currentPage,
  total,
  onPageChange,
  onDelete,
  onUpdate,
}: TCashRegisterList) => {
  const { t } = useTranslation(['financialSettings']);
  const { canManage } = usePermissions();

  return (
    <>
      <Table
        scroll={{ x: 'max-content' }}
        columns={getCashRegisterColumns({ t, onDelete, onUpdate, canManage: canManage(Resource.CASH_REGISTER) })}
        dataSource={cashRegisters}
        rowKey="id"
        loading={isLoading}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} hideOnSinglePage />
    </>
  );
};

export default CashRegisterList;
